import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'

import { CBadge } from '@coreui/react'

export const AppSidebarNav = ({ items }) => {
  const location = useLocation()
  const navLink = (name, icon, badge) => {
    return (
      <>
        {icon && icon}
        {name && name}
        {badge && (
          <CBadge color={badge.color} className="ms-auto">
            {badge.text}
          </CBadge>
        )}
      </>
    )
  }

  const navItem = (item, index) => {
    const { component, name, badge, icon, ...rest } = item
    const Component = component

    // For items with 'to' prop (navigation links), use NavLink as the component
    if (rest.to && !rest.items) {
      // If the component is CNavItem, render NavLink as the component to avoid nested <a>
      if (Component && Component.displayName === 'CNavItem') {
        return (
          <Component key={index} {...rest} component={NavLink} href={rest.to} className="nav-link">
            {navLink(name, icon, badge)}
          </Component>
        )
      }
      // Otherwise, fallback to the original rendering
      return (
        <Component key={index} {...rest}>
          <NavLink href={rest.to} className="nav-link">
            {navLink(name, icon, badge)}
          </NavLink>
        </Component>
      )
    }

    // For other items, render normally
    return (
      <Component key={index} {...rest}>
        {navLink(name, icon, badge)}
      </Component>
    )
  }
  const navGroup = (item, index) => {
    const { component, name, icon, to, ...rest } = item
    const Component = component
    return (
      <Component
        idx={String(index)}
        key={index}
        toggler={navLink(name, icon)}
        visible={location.pathname.startsWith(to)}
        {...rest}
      >
        {item.items?.map((item, index) =>
          item.items ? navGroup(item, index) : navItem(item, index),
        )}
      </Component>
    )
  }

  return (
    <React.Fragment>
      {items &&
        items.map((item, index) => (item.items ? navGroup(item, index) : navItem(item, index)))}
    </React.Fragment>
  )
}

AppSidebarNav.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
}
